import ResizableSplitView from "@components/ResizableSplitView/ResizableSplitView";
import {NotebookNavigator} from "./components/notebook-navigator/NotebookNavigator.tsx";
import {NoteEditor} from "./components/note-editor/NoteEditor.tsx";
import {notebookStore} from "./notebookStore.ts";
import {useEffect} from "react";
import {NotebookService} from "@services/notebook/notebookService";
import {Paths} from "../../paths.tsx";
import "./notes.scss";

interface NotebookPageProps {
    notebookId: number
}

export const NotebookPage = (props: NotebookPageProps) => {

    const {
        notebookId = 40
    } = props;

    // The campaigns a note can be filed against (MPN-1640). Fetched here rather than
    // passed down, because the pop-out window mounts this same component with nothing
    // but a notebook id.
    useEffect(() => {
        let cancelled = false;
        new NotebookService()
            .getNotebookDetails(notebookId)
            .then((nb: any) => {
                if (!cancelled) notebookStore.campaigns = nb?.campaigns ?? [];
            })
            // A missing campaign list costs the selector, not the notebook.
            .catch(() => { if (!cancelled) notebookStore.campaigns = []; });
        return () => { cancelled = true; };
    }, [notebookId]);

    const handlePopOut = () => {
        const noteId = notebookStore.selectedNote?.id;
        const noteParam = noteId && noteId !== -1 ? `?noteId=${noteId}` : '';
        window.open(
            `${import.meta.env.BASE_URL}${Paths.NOTEBOOK_POPOUT}/${notebookId}${noteParam}`,
            '_blank',
            'width=1200,height=800',
        );
    };

    return (
        <div className="notes">
            <div className="notes__head">
                <i className="bi bi-journal-text" style={{color: "#64748b"}}/>
                <span className="notes__title">Notebook</span>
                <button
                    type="button"
                    className="notes__ghost ms-auto"
                    title="Pop out notebook"
                    onClick={handlePopOut}
                >
                    <i className="bi bi-box-arrow-up-right"/>
                    Pop out
                </button>
                <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    style={{fontSize: "0.72rem"}}
                    onClick={() => { notebookStore.showNewFromTemplate = true; }}
                >
                    From template
                </button>
            </div>

            <div className="notes__split">
                <ResizableSplitView
                    storageKey="notebook.leftPanel.width"
                    defaultLeftSize={260}
                    minLeftSize={200}
                    minRightSize={400}
                    dividerSize={0}
                    showHandle={false}
                    left={<NotebookNavigator notebookId={notebookId}/>}
                    right={
                        <div className="notes-doc">
                            <NoteEditor notebookId={notebookId}/>
                        </div>
                    }
                />
            </div>
        </div>
    )
}
